module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_6005.11f9a0fa.png";